import { render, staticRenderFns } from "./FuncionalidadeCustomizadaNovo.vue?vue&type=template&id=2023902a&scoped=true"
import script from "./FuncionalidadeCustomizadaNovo.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023902a",
  null
  
)

export default component.exports